import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { Text, Localizer } from 'preact-i18n';
import linkstate from 'linkstate';

@observer
class SendFriendlyReminder extends Component {
    constructor(props) {
        super(props);
        const { newSale } = props;
        const visitor = newSale && newSale.visitors && newSale.visitors[0];
        this.state = {
            to: (visitor && (visitor.invoiceEmail || visitor.email)) || '',
            subject: '',
            body: '',
            sending: false,
            sent: false,
            error: null,
        };
    }

    onClickSend = async (e) => {
        e.preventDefault();
        const { newSale, callback = () => {} } = this.props;
        const { saleStore } = this.props.stores;
        const { to, subject, body } = this.state;

        if (!to) {
            this.setState({ error: 'Missing recipient email.' });
            return;
        }

        this.setState({ sending: true, sent: false, error: null });

        const response = await saleStore.friendlyReminder({
            sale: newSale,
            to,
            subject,
            body,
        });

        if (response && response.status === 200) {
            this.setState({ sending: false, sent: true });
            callback(response);
        } else {
            this.setState({ sending: false, error: 'Send failed' });
        }
    }

    onClickClose = (e) => {
        e.preventDefault();
        const { appState } = this.props.stores;
        const { drawerLevel = 1 } = this.props;
        appState.toggleDrawer(false, drawerLevel);
    }

    render() {
        const { newSale } = this.props;
        const { to, subject, body, sending, sent, error } = this.state;
        const visitor = newSale && newSale.visitors && newSale.visitors[0];
        const visitorName = visitor ? `${visitor.firstname || ''} ${visitor.lastname || ''}`.trim() : '';

        return (
            <div class='p-3'>
                <h4>
                    <i class='fa-solid fa-paper-plane-top me-2' />
                    <Text id='dyrejournal.friendly-reminder'>Friendly reminder</Text>
                </h4>

                <p class='text-body-secondary small'>
                    <Text id='dyrejournal.friendly-reminder-help'>
                        Send a short, friendly email reminding the customer to complete payment. The pay link is added automatically.
                    </Text>
                </p>

                {visitorName ? <p><strong>{visitorName}</strong></p> : null}

                <div class='mb-3'>
                    <label class='form-label'>
                        <Text id='dyrejournal.to'>To</Text>
                    </label>
                    <input
                        type='email'
                        class='form-control'
                        value={to}
                        onInput={linkstate(this, 'to')}
                        placeholder='customer@example.com'
                    />
                </div>

                <div class='mb-3'>
                    <label class='form-label'>
                        <Text id='dyrejournal.subject'>Subject</Text>
                    </label>
                    <Localizer>
                        <input
                            type='text'
                            class='form-control'
                            value={subject}
                            onInput={linkstate(this, 'subject')}
                            placeholder={<Text id='dyrejournal.friendly-reminder-subject-placeholder'>Leave blank to use default</Text>}
                        />
                    </Localizer>
                </div>

                <div class='mb-3'>
                    <label class='form-label'>
                        <Text id='dyrejournal.body'>Body</Text>
                    </label>
                    <Localizer>
                        <textarea
                            class='form-control'
                            rows='8'
                            value={body}
                            onInput={linkstate(this, 'body')}
                            placeholder={<Text id='dyrejournal.friendly-reminder-body-placeholder'>Leave blank to use default</Text>}
                        />
                    </Localizer>
                </div>

                {error ? <div class='alert alert-danger'>{error}</div> : null}
                {sent ? <div class='alert alert-success'><Text id='dyrejournal.friendly-reminder-sent'>Reminder sent.</Text></div> : null}

                <div class='d-flex gap-2'>
                    <button
                        type='button'
                        class='btn btn-primary'
                        onClick={this.onClickSend}
                        disabled={sending || sent}
                    >
                        <i class={`fa-solid fa-paper-plane-top ${sending ? 'fa-bounce' : ''} me-2`} />
                        <Text id='dyrejournal.send'>Send</Text>
                    </button>
                    <button type='button' class='btn btn-outline-secondary' onClick={this.onClickClose}>
                        <Text id='dyrejournal.close'>Close</Text>
                    </button>
                </div>
            </div>
        );
    }
}

export default SendFriendlyReminder;
